import React from 'react';
import styled from 'styled-components';
import { darken, lighten, rgba } from 'polished';
import DynamicMaterialIcon from '../../../../../../../components/DynamicMaterialIcon/DynamicMaterialIcon';



const PresetButtonWrapper = styled.div`
  padding: 10px;
  margin: 10px;
  color: ${(props) => props?.fontColor || 'white'};
  text-align: center;
  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};
  border-radius: 3px;

  &:hover,
  &.active {
    cursor: pointer;
    background: linear-gradient(60deg, ${(props) => props.color}, ${(props) => darken(0.1, props.color)});
  }
`;

const PresetButton = ({ label, color, fontColor, onClick, active, icon }) => {
  let labelFontSize = '1em';
  switch(true){
    case label.length > 8 && label.length<10:
      labelFontSize = '0.95em';
      break;
    case label.length > 10 && label.length<=20:
      labelFontSize = '0.95em';
      break;
    case label.length > 20 && label.length<=25:
      labelFontSize = '0.85em';
      break;
    case label.length > 25:
      labelFontSize = '0.75em';
      break;
    default:
      break;
  }

  return (
    <PresetButtonWrapper color={color} fontColor={fontColor} onClick={onClick} className={active && 'active'}>
      <div
        style={{
          width: '100px',
          height: '70px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div style={{flex: 1}}>
          <DynamicMaterialIcon name={icon} />
        </div>
        <div style={{flex: 3, overflow: 'hidden', fontSize: labelFontSize, alignItems: 'center', display:'flex'}}>
          <div>
          {label}
          </div>
        </div>
      </div>
    </PresetButtonWrapper>
  );
};

export default PresetButton;
